/* eslint-disable func-style */
const RightPanel = () => import('@/components/RightPanel.vue');// 右滑详情页面
const OfflineCharge = () => import('@/pages/OnSiteService/OfflineCharge.vue');
const OfflineChargeExcel = () => import('@/pages/OnSiteService/OfflineChargeExcel.vue');
const ChargeItemExcel = () => import('@/pages/OnSiteService/ChargeItemExcel.vue');
const OfflineCollectionRecord = () => import('@/pages/OnSiteService/OfflineCollectionRecord.vue');
const OfflineRefund = () => import('@/pages/OnSiteService/OfflineRefund.vue');
const OfflineRefundRecord = () => import('@/pages/OnSiteService/OfflineRefundRecord.vue');
const OfflineRightPage = () => import('@/pages/OnSiteService/OfflineRightPage.vue');
const OfflineRefundDetails = () => import('@/pages/OnSiteService/OfflineRefundDetails.vue');
const OfflineRefundExcel = () => import('@/pages/OnSiteService/OfflineRefundExcel.vue');
const OfflineStatistic = () => import('@/pages/OnSiteService/OfflineStatistic.vue');
const DropOutAndRefund = () => import('../pages/OnSiteService/DropOutAndRefund.vue');
const DropOutRefundRecord = () => import('../pages/OnSiteService/DropOutRefundRecord');
const DropOutRefundDetails = () => import('../pages/OnSiteService/DropOutRefundDetails');


const serviceRouter = [
	{ path: '/DropOutAndRefund', name: 'DropOutAndRefund', component: DropOutAndRefund },
	{
		path: '/DropOutRefundRecord',
		meta: { parent: '/DropOutAndRefund' },
		name: 'DropOutRefundRecord',
		component: DropOutRefundRecord,
		children: [
			{
				path: '/DropOutRefundRightPanel',
				name: 'DropOutRefundRightPanel',
				meta: { parent: '/DropOutRefundRecord' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/DropOutRefundDetails/:subParams',
						name: 'DropOutRefundDetails',
						meta: { parent: '/DropOutRefundRightPanel' },
						component: DropOutRefundDetails,
					},
				],
			},
		],
	},
	{ path: '/OfflineCharge', name: 'OfflineCharge', component: OfflineCharge },
	{ path: '/OfflineChargeExcel', name: 'OfflineChargeExcel', component: OfflineChargeExcel },
	{ path: '/ChargeItemExcel', name: 'ChargeItemExcel', component: ChargeItemExcel },
	{
		path: '/OfflineCollectionRecord',
		name: 'OfflineCollectionRecord',
		component: OfflineCollectionRecord,
		children: [
			{
				path: '/OfflineRightPanel',
				name: 'OfflineRightPanel',
				component: RightPanel,
				meta: { parent: '/OfflineCollectionRecord' },
				children: [
					{ // 右滑详情页面
						path: '/OfflineRightPage/:subParams',
						name: 'OfflineRightPage',
						meta: { parent: '/OfflineCollectionRecord' },
						component: OfflineRightPage,
					},
				],
			},
		],
	},
	{ path: '/OfflineRefund', name: 'OfflineRefund', component: OfflineRefund },
	{
		path: '/OfflineRefundRecord',
		meta: { parent: '/OfflineRefund' },
		name: 'OfflineRefundRecord',
		component: OfflineRefundRecord,
		children: [
			{
				path: '/OfflineRefundRightPanel',
				name: 'OfflineRefundRightPanel',
				meta: { parent: '/OfflineRefundRecord' },
				component: RightPanel,
				children: [
					{ // 右滑详情页面
						path: '/OfflineRefundDetails/:subParams',
						name: 'OfflineRefundDetails',
						meta: { parent: '/OfflineRefundRecord' },
						component: OfflineRefundDetails,
					},
				],
			},
		],
	},
	{ path: '/OfflineRefundExcel', meta: { parent: '/OfflineRefund' }, name: 'OfflineRefundExcel', component: OfflineRefundExcel },
	{ path: '/OfflineStatistic', name: 'OfflineStatistic', component: OfflineStatistic },

];
export default serviceRouter;
